// src/firebasePublic.js
// LINE から開かれる画面(/auth/line)専用の Firebase インスタンス（Auth を持たない）。
//
// ⚠既定の app には Auth が登録されており、その app の httpsCallable は**呼び出しのたびに
//   Auth の初期化完了を待つ**。LINE の webview では Auth の初期化(端末内の保存領域の読み込み)が
//   数秒〜数十秒、ときに無限に止まることがあり、HTTPリクエストが1本も出ないまま
//   「ローディングのまま進まない」になる。
//   Core(~/suomi-admin)が 2026-09-28 に同じ症状で特定済みで、向こうも src/firebasePublic.js で
//   回避している（あちらの CLAUDE.md 参照）。顧客アプリでも 2026-10-01 に同じ踏み方をした:
//   LINEログインの2回目で stage=signin のまま停止し、Cloud Run にリクエストが0件だった。
//
// ログイン前に呼ぶ callable（loginWithLine / チケット経由の linkLineToCurrentUser）は
// どちらも認証不要なので、こちらの app を使う。
import { initializeApp, getApps } from "firebase/app";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const publicApp =
  getApps().find((a) => a.name === "public") ||
  initializeApp(firebaseConfig, "public");

export const publicFunctions = getFunctions(publicApp, "asia-northeast1");
